/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import {
  Button,
  colors,
  Drawer,
  FlexContainer,
  Icon,
  useBreakpointComponent,
  Text,
  Modal,
  Stack,
  ArrowLink,
  Container
} from "@carrotfertility/carotene"
import styled from "styled-components"
import { SidebarFilters } from "./SidebarFilters"
import { SwitchViewButton } from "./SwitchViewButton"
import { ZendeskArrowLink } from "components/views/atoms/links/ZendeskArrowLink"
import { SupportCenterLinks } from "utils/SupportCenterLinks"
import { RetinaImage } from "../RetinaImage"
import { Benefit } from "pages/provider-finder/types/Benefit"
import { FormattedMessage } from "react-intl"

const StyledButton = styled(Button)`
  background: #ffffff;
  border: 2px solid ${colors.base.black10};
  color: ${colors.base.black80};
  padding: 8px 20px 12px 20px;
  &:hover {
    background: #ffffff;
    border: 2px solid ${colors.base.black10};
  }
`

const FilterButton = ({
  displaySidebarDrawer,
  setDisplaySidebarDrawer
}: {
  displaySidebarDrawer: boolean
  setDisplaySidebarDrawer: (inputValue: boolean) => void
}): JSX.Element => {
  const { pathname } = useLocation()
  if (pathname.includes("providers")) {
    return (
      <StyledButton onClick={() => setDisplaySidebarDrawer(!displaySidebarDrawer)}>
        <FlexContainer gap="12px" justifyContent="center" alignItems="end">
          <Icon name="filter" />
          <FormattedMessage defaultMessage="Filter" />
        </FlexContainer>
      </StyledButton>
    )
  }
  return null
}

const CTAModal = (): JSX.Element => {
  const [open, setOpen] = React.useState(false)
  const { pathname } = useLocation()
  if (pathname.includes("providers")) {
    return (
      <Container>
        <Text font="gotham" weight="bold" size="small" onClick={() => setOpen(true)} sx={{ cursor: "pointer" }}>
          <FormattedMessage defaultMessage="Can we help?" />
        </Text>
        <Modal isDismissable showClose open={open} onClose={() => setOpen(false)}>
          <Container paddingLeftRight="large" padding="0px 0px 48px 0px">
            <Stack spacing="tiny" padding="0px 0px 24px 0px">
              <RetinaImage height={24} width={24} name="icn-help" />
              <Text font="gotham" weight="bold">
                <FormattedMessage defaultMessage="Can we help?" />
              </Text>
            </Stack>
            <Stack spacing="tiny">
              <ArrowLink to="/talk-to-carrot/sendmessage/helpfindingprovider">
                <FormattedMessage defaultMessage="Contact our Care Navigation team" />
              </ArrowLink>
              <ZendeskArrowLink supportCenterLink={SupportCenterLinks.CARROT_PROVIDERS}>
                <FormattedMessage defaultMessage="Learn more about providers" />
              </ZendeskArrowLink>
            </Stack>
          </Container>
        </Modal>
      </Container>
    )
  }
  return null
}
const FilterDrawer = ({ benefit }: { benefit: Benefit }): JSX.Element => {
  const [displaySidebarDrawer, setDisplaySidebarDrawer] = useState(false)
  const { search: geocodeQueryString } = useLocation()
  const params = new URLSearchParams(geocodeQueryString)
  const searchLocation = params.get("search")

  useEffect(() => {
    setDisplaySidebarDrawer(false)
  }, [geocodeQueryString])

  return (
    <>
      <FlexContainer justifyContent="flex-end" direction="row" alignItems="center" gap="small">
        <CTAModal />
        <FilterButton setDisplaySidebarDrawer={setDisplaySidebarDrawer} displaySidebarDrawer={displaySidebarDrawer} />
      </FlexContainer>
      <Drawer
        background="lightGrey"
        placement="right"
        open={displaySidebarDrawer}
        onClose={() => setDisplaySidebarDrawer(false)}
      >
        <SwitchViewButton />
        <SidebarFilters searchLocation={searchLocation} benefit={benefit} />
      </Drawer>
    </>
  )
}

export const ResponsiveDrawer = ({ benefit }: { benefit: Benefit }): JSX.Element => {
  const element = useBreakpointComponent([
    <FilterDrawer key={"small"} benefit={benefit} />,
    <FilterDrawer key={"medium"} benefit={benefit} />,
    <FilterDrawer key={"large"} benefit={benefit} />,
    false
  ])
  return element || <></>
}
